export default "__VITE_ASSET__daa4e828__"